/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import { getScaledValue } from '../../ui/styled';
import Icons from './../../assets/icons';

export const BannerButton = styled.TouchableOpacity.attrs(
  (props: { spaced?: string; active?: boolean; icon?: string; theme: { primary: string } }) => ({
    underlayColor: props.theme.primary,
  }),
)`
  padding: ${getScaledValue(4)}px ${getScaledValue(8)}px;
  align-self: flex-start;
  border-radius: ${getScaledValue(3)}px;
  border-color: transparent;
  border-width: ${getScaledValue(2)}px;

  ${(props: { spaced?: string; active?: boolean; icon?: string; theme: { primary: string } }) =>
    props.spaced
      ? `
            margin-left: ${getScaledValue(8)}px;
        `
      : `
        `}

  ${(props: { spaced?: string; active?: boolean; icon?: string; theme: { primary: string } }) =>
    props.active
      ? `
            border-color: ${props.theme.primary};
            background-color: ${props.theme.primary}; 
        `
      : `
            background-color: #ffffff;
        `} 

    flex-direction: row;
  align-items: center;
`;
export const BannerButtonIcon = styled(Icons).attrs(
  (props: { spaced?: string; active?: boolean; icon?: string; theme: { primary: string } }) => ({
    width: getScaledValue(13),
    height: getScaledValue(13),
    icon: props.active ? `${props.icon}` : `${props.icon}black`,
    fill: !props.active ? '#000000' : '#ffffff',
  }),
)`
  margin-right: ${getScaledValue(4)}px;
`;
export const BannerButtonText = styled.Text.attrs({})`
  font-size: ${getScaledValue(14)}px;
  color: #ffffff;
  font-family: PTSans-Bold;
  padding: 0 ${getScaledValue(4)}px 0 ${getScaledValue(8)}px;

  ${(props: { spaced?: string; active?: boolean; icon?: string; theme: { primary: string } }) =>
    !props.active
      ? `
            color: #000000;
        `
      : ``}
`;
